import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { ROL_ADMINISTRADOR, ROL_PERFIL_ADMINISTRADOR } from '../constants/roles';

// Analogo a PermisosMenuContext, pero para los items de menu que el SUPERADMIN
// deshabilito para toda la administradora (ver pantalla Administradoras). Aplica
// a los roles Administrador y Perfil Administrador; el resto de los roles usan
// menus propios (Superadmin, Portero, Usuario Barrio) que no pasan por aca.
export const AdministracionMenuContext = createContext();

export const AdministracionMenuProvider = ({ children }) => {
    const { administracionId, rolId } = useAuth();
    const aplica = rolId === ROL_ADMINISTRADOR || rolId === ROL_PERFIL_ADMINISTRADOR;
    const [menuOcultosAdministracion, setMenuOcultosAdministracion] = useState([]);
    const [loadingAdministracionMenu, setLoadingAdministracionMenu] = useState(aplica);

    useEffect(() => {
        if (!aplica || !administracionId) {
            setMenuOcultosAdministracion([]);
            setLoadingAdministracionMenu(false);
            return;
        }

        const HOST_API = process.env.REACT_APP_URL;
        setLoadingAdministracionMenu(true);
        axios.get(`${HOST_API}api/administracionMenu/GetMenuOcultos`, { params: { administracionId } })
            .then(({ data }) => setMenuOcultosAdministracion(data ?? []))
            .catch(() => setMenuOcultosAdministracion([]))
            .finally(() => setLoadingAdministracionMenu(false));
    }, [administracionId, rolId, aplica]);

    return (
        <AdministracionMenuContext.Provider value={{ menuOcultosAdministracion, loadingAdministracionMenu }}>
            {children}
        </AdministracionMenuContext.Provider>
    );
};

export const useAdministracionMenu = () => useContext(AdministracionMenuContext);
